var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5676 20.7928C22.8269 23.0439 19.9246 24.1671 17.851 23.9799C15.0191 23.7239 11.9376 22.2215 9.59853 20.5672C6.16026 18.1353 2.93957 14.3738 1.06284 10.382C-0.263516 7.56126 -0.561105 4.09259 1.41162 1.52148C2.1412 0.571112 2.93157 0.0639302 4.11553 0.0047323C5.76027 -0.0752648 5.99066 0.865502 6.55544 2.33105C6.97623 3.42701 7.53781 4.54537 7.85139 5.68133C8.43857 7.80125 6.38585 7.88925 6.12666 9.62199C5.96666 10.7147 7.28981 12.1803 7.88819 12.9595C9.04157 14.477 10.4542 15.7786 12.0608 16.8041C12.9728 17.3785 14.4416 18.4137 15.4847 17.8425C17.0911 16.9625 16.9407 14.2538 19.1854 15.1706C20.3485 15.6442 21.4749 16.3274 22.5853 16.9257C24.302 17.8489 24.222 18.8057 23.5676 20.7928C24.0572 19.308 23.0781 22.2775 23.5676 20.7928Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.19e9b68798fcedc2654f0c8600a1dabf.svg";
export { ForwardRef as ReactComponent };